module.exports = __webpack_public_path__ + "static/media/head-side-headphones.fcd5438f.svg";